import { Typography } from '@material-tailwind/react';
import TimeSection, { Time } from './TimeSection';
import { DateSection } from '.';

interface DateTimeSectionProps {
  id: string;
  title: string;
  date: Date;
  onTimeChange: (time: Time) => void;
  shouldUpdate: boolean;
  timeFormat: '12' | '24';
  disableTime?: boolean;
  isLocked: boolean;
}

const DateTimeSection: React.FC<DateTimeSectionProps> = ({
  id,
  title,
  date,
  onTimeChange,
  shouldUpdate,
  timeFormat,
  disableTime,
  isLocked
}) => {
  return (
    <div className="w-1/2 gap-3 pl-5 pr-1 border-t border-neutral-grey200">
      <Typography 
        variant="h6" 
        className="font-light mt-2 text-gray-600 text-sm uppercase"
        placeholder=""
        onResize={() => {}}
        onResizeCapture={() => {}}
        onPointerEnterCapture={() => {}}
        onPointerLeaveCapture={() => {}}
      >
        {title}
      </Typography>
      <div className="flex">
        <div className="w-3/4">
          <DateSection date={date} />
        </div>
        <div className="flex items-center">
          <TimeSection
            id={id}
            initialTime={{
              hour: date.getHours().toString(),
              minute: date.getMinutes().toString(),
            }}
            onTimeChange={onTimeChange}
            updateTime={shouldUpdate}
            timeFormat={timeFormat}
            disabled={disableTime}
            isLocked={isLocked}
          />
        </div>
      </div>
    </div>
  );
};

export default DateTimeSection; 